module.exports = __webpack_public_path__ + "img/ur.d74d7ec1.png";